import { savePlantDetail } from '@apis';
import type { PlantDetailFormType } from '@schema';
import { Plant } from '@types';
import { useMutation } from '@tanstack/react-query';

import usePlantQueryInvalidation from './usePlantQueryInvalidation';

type SavePlantDetailVariables = {
  plant: Plant;
  formData: PlantDetailFormType;
};

const useSavePlantDetail = () => {
  const { invalidatePlantList } = usePlantQueryInvalidation();
  const { invalidatePlantDetail } = usePlantQueryInvalidation();

  return useMutation({
    mutationFn: async ({ plant, formData }: SavePlantDetailVariables) => {
      const response = await savePlantDetail(plant, formData);

      if (response.codeHTTP !== 200) {
        throw new Error('Failed to save plant detail.');
      }

      await invalidatePlantList();
      await invalidatePlantDetail(plant.plant_id);

      return response;
    },
  });
};

export default useSavePlantDetail;
